import { Box, Typography } from '@mui/material';

export function InputRow({ name, value }) {
  const nonNullValue = value ?? null;
  if (nonNullValue === null) return null;

  return (
    <Box display="flex" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2">{name}</Typography>
      <Typography variant="body2">{nonNullValue}</Typography>
    </Box>
  );
}
